import { FC } from "react";
import { Helmet } from "react-helmet-async";

import { helmetConfig } from "@pages/constanst";

import { ERoutes } from "@utils/constants";
import { isSnapDev } from "@utils/externalScriptsLoader";
import { TFunction } from "i18next";

import { renderMeta } from "./utils";

type THelmetProps = {
  t: TFunction | ((key: string, props?: Record<string, any>) => string);
  route: ERoutes;
  titleProps?: Record<string, unknown>;
  descriptionProps?: Record<string, unknown>;
  linkProps?: Record<string, unknown>;
};

const defaults = {
  title: "helmet.title",
  description: "helmet.description",
  link: "helmet.link",
  siteName: "helmet.siteName",
  twitterSite: "helmet.twitterSite",
};

export const CustomHelmet: FC<THelmetProps> = ({
  t,
  route,
  titleProps = {},
  descriptionProps = {},
  linkProps = {},
}) => {
  const cfg = helmetConfig[route] || {};

  const cfgWithDefaults = {
    ...defaults,
    ...cfg,
  };

  const title = cfgWithDefaults.title ? t(cfgWithDefaults.title, titleProps) : undefined;

  const description = cfgWithDefaults.description ? t(cfgWithDefaults.description, descriptionProps) : undefined;
  const link = cfgWithDefaults.link ? t(cfgWithDefaults.link, linkProps) : undefined;
  const siteName = cfgWithDefaults.siteName ? t(cfgWithDefaults.siteName) : undefined;
  const twitterSite = cfgWithDefaults.twitterSite ? t(cfgWithDefaults.twitterSite) : undefined;

  const metaTags: Record<string, string | undefined> = {
    description: description,
    "og:title": title,
    "og:description": description,
    "og:url": link,
    "og:site_name": siteName,
    "twitter:title": title,
    "twitter:description": description,
    "twitter:site": twitterSite,
    robots: isSnapDev ? "noindex, nofollow" : "index, follow",
    ...cfg.extra,
  };

  const filteredMetaTags = Object.entries(metaTags).filter(([, content]) => content);

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={link} />
      {filteredMetaTags.map(renderMeta)}
    </Helmet>
  );
};
